export default __webpack_public_path__ + "static/media/banner.5d57d628.jpg";